import { APPROVAL } from '@/api/apiModules'

export default {
  viewType: 'table',
  module: APPROVAL,
  allowStatus: {
    ApprovalChannelUser: { approvalStatus: ['PENDING'] },
    DisableChannelUser: { enabled: [true] },
    EnableChannelUser: { enabled: [false] }
  },
  toolbar: {
    searchPlaceholder: '请输入渠道用户姓名或手机号码',
    searchFieldNameArr: ['realName', 'userName', 'telephoneNum'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: '废弃账号',
        props: {
          type: 'primary',
          icon: 'el-icon-delete'
        },
        action: 'DisableChannelUser'
      },
      {
        slot: 'refresh-rigtht',
        label: '启用账号',
        props: {
          type: 'success',
          icon: 'el-icon-check'
        },
        action: 'EnableChannelUser'
      },
      {
        slot: 'refresh-rigtht',
        label: '同步渠道账号',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'SyncChannelUser'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          type: 'selection',
          width: 55
        }
      },
      {
        props: {
          label: '真实名称',
          prop: 'realName'
        }
      },
      {
        props: {
          label: '账号状态',
          width: 105,
          prop: 'enabled',
          filters: [
            {
              text: '可用',
              value: true
            },
            {
              text: '不可用',
              value: false
            }
          ]
        },
        filter: true,
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          if (data.enabled) {
            const renderItem = [<el-tag type="success">可用</el-tag>]
            return renderItem
          } else {
            const renderItem = [<el-tag type="info">不可用</el-tag>]
            return renderItem
          }
        }
      },
      {
        props: {
          label: '审批状态',
          width: 105,
          prop: 'approvalStatus'
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '电话号码',
          prop: 'telephoneNum'
        }
      },
      {
        props: {
          label: 'form.common_email',
          prop: 'email'
        }
      },
      {
        props: {
          label: '审批意见',
          prop: 'comment'
        }
      },
      {
        props: {
          label: '审批时间',
          prop: 'approvalTime'
        },
        dataType: 'date'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '审批',
        command: 'ApprovalChannelUser',
        name: 'ApprovalChannelUser'
      },
      {
        icon: 'el-icon-edit',
        label: '废弃账号',
        command: 'DisableChannelUser',
        name: 'DisableChannelUser'
      },
      {
        icon: 'el-icon-edit',
        label: '启用账号',
        command: 'EnableChannelUser',
        name: 'EnableChannelUser'
      }
    ]
  }
}
